"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Play = function Play() {
  return _react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 57 57"
  }, _react.default.createElement("circle", {
    cx: "28.5",
    cy: "28.5",
    r: "28.5",
    fill: "#242523"
  }), _react.default.createElement("path", {
    stroke: "#63DC3E",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "3",
    d: "M20 14l23 15-23 15V14z"
  }));
};

var _default = Play;
exports.default = _default;